import type { HelpSectionId, HelpSectionsMap } from './types';
import { ruHelpSections } from './ru';
import { enHelpSections } from './en';
import { deHelpSections } from './de';
import { frHelpSections } from './fr';
import { esHelpSections } from './es';
import { itHelpSections } from './it';

const maps: Record<string, HelpSectionsMap> = {
  ru: ruHelpSections,
  en: enHelpSections,
  de: deHelpSections,
  fr: frHelpSections,
  es: esHelpSections,
  it: itHelpSections,
};

export { HELP_SECTION_IDS } from './types';
export type { HelpSectionId, HelpBlock, HelpSection } from './types';

export const getHelpSections = (languageCode: string): HelpSectionsMap => (
  maps[languageCode] ?? enHelpSections
);

export const getDefaultHelpSectionId = (): HelpSectionId => 'start';
